<template>
  <div>
    <template v-if="header.id === 'checkbox'">
      <vchecklabel v-model="selected" />
    </template>

    <template v-else-if="header.id === 'avatar'">
      <div class="column column-avatar column-link" :class="{ disabled: is_response_disabled }">
        <router-link :to="path" class="response-link response-link__avatar" :disabled="is_response_disabled">
          <div v-if="model.preview_link && visibility && !refusal" class="avatar-holder">
            <img class="avatar-holder__img" :src="model.preview_link" />
          </div>
          <div v-else-if="!hasVideo && visibility && !refusal" class="avatar-holder avatar-holder--audio">
            <img src="/static/images/elements/equalizer.jpg" />
          </div>

          <div v-else-if="!visibility || refusal" class="avatar-empty">
            <img src="/static/images/elements/hide-avatar.png" />
          </div>

          <div v-else class="avatar-empty">
            <img src="/static/images/elements/empty-avatar.png" />
          </div>
        </router-link>

        <router-link :to="path" class="response-link response-link__candidate" :disabled="is_response_disabled">
          <div :class="['candidate-name', { 'candidate-name__hide': !visibility || refusal }]">
            <span> {{ fullNameToDisplay }} </span>
          </div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'vacancy'">
      <div class="column column-vacancy column-link" :class="{ disabled: is_response_disabled }">
        <router-link :to="path" class="response-link" :disabled="is_response_disabled">
          <div :class="['candidate-position', { 'candidate-position__hide': !visibility || refusal }]">
            <span :title="vacancy.name"> {{ vacancy.name }} </span>
            <span v-if="!vacancy.is_active && !vacancy.is_deleted" class="archive-label">
              {{ $tr('vacancies.archiveLabel') }}
            </span>
            <span v-if="vacancy.is_deleted" class="remove-label">
              {{ $tr('vacancies.removeLabel') }}
            </span>
          </div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'status'">
      <div :class="{ disabled: is_response_disabled }">
        <div
          v-if="status"
          v-on-click-away="hideStatusesDropdown"
          :class="[
            'candidate-info-item',
            {
              'candidate-info-unpaid': not_paid
            }
          ]"
        >
          <div class="cell-block cell-block__status">
            <div class="cell-statuses_label" @click="changeStatusesDropdownVisible(!isStatusesDropdownVisible)">
              {{ status }}
              <div class="cell-statuses_icon" :class="{ 'is-active': isStatusesDropdownVisible }">
                <img src="/static/icons/responses-list-dropdown.svg" />
              </div>
            </div>

            <transition name="fade">
              <div v-if="isStatusesDropdownVisible" class="cell-statuses_dropdown" :class="{ loading: loadingStatus }">
                <ul class="cell-statuses_list">
                  <li
                    v-for="item in statusesFilteredByRole"
                    :key="item.id"
                    class="cell-statuses_item"
                    @click="statusChange(item)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </transition>
          </div>

          <span v-if="model.is_hidden" class="remove-label">
            {{ $tr('response.hiddenByCandidate') }}
          </span>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'refuse'">
      <div class="column column-status column-link" :class="{ disabled: is_response_disabled }">
        <router-link :to="path" class="response-link" :disabled="is_response_disabled">
          <div v-if="refusal" class="candidate-refuse">
            <span>{{ refusal.reason }}</span>
          </div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'rating'">
      <div class="column column-rating column-link" :class="{ disabled: is_response_disabled }">
        <router-link :to="path" class="response-link" :disabled="is_response_disabled">
          <div class="stars">
            <span v-for="i in stars" :key="i" class="star green">
              <i class="fa fa-star"></i>
            </span>
            <span v-for="i in stars_unselected" :key="i" class="star gray">
              <i class="fa fa-star"></i>
            </span>
          </div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'date'">
      <div class="column column-date column-link" :class="{ disabled: is_response_disabled }">
        <router-link :to="path" class="response-link" :disabled="is_response_disabled">
          <div>{{ created_at_time }}</div>
          <div>{{ created_at }}</div>
        </router-link>
      </div>
    </template>

    <template v-else-if="header.id === 'date_sent'">
      <div class="column column-date column-link" :class="{ disabled: is_response_disabled }">
        <router-link v-if="date_sent" :to="path" class="response-link" :disabled="is_response_disabled">
          <div>{{ date_sent_time }}</div>
          <div>{{ date_sent }}</div>
        </router-link>
        <div v-else>
          {{ $tr('responses.notFinished') }}
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'source'">
      <div class="column column-source column-link" :class="{ disabled: is_response_disabled }">
        <span v-if="model.social_source" v-tooltip.top-center="decodeURI(model.social_source)">
          {{ model.social_source | parseSource }}
        </span>

        <span v-else v-tooltip.top-center="decodeURI(model.source.name)">
          {{ model.source.name | parseSource }}
        </span>
      </div>
    </template>

    <template v-else-if="header.id === 'tags'">
      <div class="column column-tags column-link" :class="{ disabled: is_response_disabled }">
        <div v-if="model.tags">
          <vcv-tags-item v-for="item in model.tags" :key="item.id" :text="item.name" is-ellipsis />
          <!-- <div v-for="(item, index) in model.tags" :key="index" class="vcv-tag vcv-tag--view">
            {{ item.name }}
          </div> -->
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'creator'">
      <div :class="{ disabled: is_response_disabled }">
        {{ vacancyCreator }}
      </div>
    </template>

    <template v-else-if="header.id === 'resume'">
      <div class="column column-resume column-link" :class="{ disabled: is_response_disabled }">
        <div class="cv-row">
          <a
            v-if="model.resume_url"
            v-tooltip="{
              content: model.resume_url,
              placement: 'top-center',
              classes: 'cv-tooltip'
            }"
            class="cv-row-resume-link"
            :href="model.resume_url"
            target="_blank"
            rel="noopener"
          >
            <svg class="cv-row-icon">
              <use xlink:href="/static/icons/cv-icons.svg#file" />
            </svg>
          </a>

          <a
            v-if="model.second_resume_url"
            v-tooltip="{
              content: model.second_resume_url,
              placement: 'top-center',
              classes: 'cv-tooltip'
            }"
            class="cv-row-resume-link"
            :href="model.second_resume_url"
            target="_blank"
            rel="noopener"
          >
            <svg class="cv-row-icon">
              <use xlink:href="/static/icons/cv-icons.svg#url" />
            </svg>
          </a>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'comments'">
      <div class="column column-comments" :disabled="is_response_disabled" :class="{ disabled: is_response_disabled }">
        <div v-if="lastCommentMessage && !commentMode" class="comment-box" @click="editLastComment">
          <span v-html="linkify(lastCommentMessage)"></span>
        </div>

        <textarea
          v-else
          ref="commentInput"
          v-model="comment"
          type="text"
          :class="['comment-text', { 'comment-text-empty': !comment.length && !is_focused }]"
          :placeholder="clippedLastCommentMessage || $tr('responses.leaveComment')"
          @blur.prevent="leaveComment"
          @focus.prevent="focus_textarea"
          @keypress="commentKeyPress"
        ></textarea>
      </div>
    </template>

    <template v-else-if="header.id.indexOf('attribute_') !== -1">
      <div v-if="model.attribute_values && model.attribute_values.length > 0">
        <div
          v-if="getCurrentAttribute(header, model).attribute.type === 'html'"
          v-html="getCurrentAttribute(header, model).value"
        ></div>

        <div v-else>
          {{ getCurrentAttribute(header, model).value }}
        </div>
      </div>
    </template>

    <template v-else>
      <div>{{ cell[header.id] || '' }}</div>
    </template>
  </div>
</template>

<script>
import IEBrowserDetector from '@/components/mixin/IEBrowserDetector';
import { ResponsesRowMixin } from '@/components/responses/tablerow/rowMixin.js';
import { linkify } from '@/_helpers/utils.js';
import { directive as VueClickAway } from 'vue-clickaway';
import VcvTagsItem from '@/components/response/VcvTagsItem.vue';

export default {
  components: {
    VcvTagsItem
  },

  directives: {
    onClickAway: VueClickAway
  },

  mixins: [IEBrowserDetector, ResponsesRowMixin],

  props: {
    model: Object,
    header: Object,
    cell: Object,

    fullName: {
      type: String,
      default: ''
    },

    statuses: {
      type: Array,
      default: () => []
    },

    loadingStatus: Boolean
  },

  data() {
    return {
      isStatusesDropdownVisible: false
    };
  },

  computed: {
    statusesFilteredByRole() {
      return this.statuses
        .filter(i => (this.isRoleRead ? !i.is_base : true))
        .filter(i => (this.model && this.model.status ? this.model.status.id !== i.id : true));
    },

    isRoleRead() {
      if (!this.model || !this.model.vacancy) {
        return false;
      }

      return this.model.vacancy.role === 'role_read';
    }
  },

  beforeDestroy() {
    this.emailTemplate = {};
  },

  methods: {
    linkify,

    async statusChange(item) {
      this.$emit('statusChange', { status: item, response: this.model });
    },

    changeStatusesDropdownVisible(val) {
      this.isStatusesDropdownVisible = val;
    },

    hideStatusesDropdown() {
      this.isStatusesDropdownVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.cv-row {
  display: flex;
  align-items: center;
}

.comment-box {
  ::v-deep a {
    cursor: pointer !important;
  }
}

.remove-label {
  padding: 3px;
  margin: 0;
  position: static;
  font-size: 10px;
  display: inline;
}

.cell-block {
  display: block;
}

.column-avatar {
  display: flex;
  align-items: center;
}

.response-link__avatar {
  width: auto;
  min-width: 84px;
  margin-right: 16px;
}

.cell-statuses_icon {
  display: flex;
  align-items: center;
  transform: rotate(180deg);
  transition: all linear 0.4s;
  opacity: 0;
  visibility: hidden;

  &.is-active {
    transform: rotate(0);
  }
}

.cell-block__status {
  position: relative;

  &:hover {
    .cell-statuses_icon {
      opacity: 1;
      visibility: visible;
    }
  }
}

.cell-statuses_label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 700;
}

.cell-statuses_list {
  padding: 0;
  list-style: none;
}

.cell-statuses_item {
  cursor: pointer;
  transition: all linear 0.4s;

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  &:hover {
    color: $green-hover;
  }
}

.cell-statuses_dropdown {
  position: relative;
  padding: 12px;
  border: 1px solid #d1d8e0;
  box-sizing: border-box;
  border-radius: 2px;
  position: absolute;
  top: calc(100% + 4px);
  left: -18px;
  min-width: 155px;
  background: #fff;
  z-index: 2;

  &.loading {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.7;
      background: #fff;
      cursor: wait;
    }
  }
}

.avatar-holder {
  &__img {
    transform: scaleX(-1);
  }
}
</style>
